/* user/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const presentation = t.partial({
  name_sortable: t.string,
});

const AttributeCodec = t.intersection([
  t.type({
    Email: t.string,
    Enabled: t.boolean,
    FirstName: t.string,
    Group: t.string,
  }),
  t.partial({
    LastName: tOptional(t.string),
    Company: tOptional(t.string),
    Department: tOptional(t.string),
    Phone: tOptional(t.string),
    LastLogin: tOptional(t.string),
    TempPassword: t.boolean,
  }),
  presentation,
]);

const DataCodec = t.intersection([
  t.type({
    id: tId,
    type: t.string,
    attributes: AttributeCodec,
  }),
  t.partial({
    createdAt: t.string,
    updatedAt: t.string,
    changePassword: t.boolean,
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

const MetaCodec = t.type({
  totalObjects: tOptional(t.number),
});

export const UserCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
    meta: tOptional(MetaCodec),
  },
  "UserCodec"
);

export type User = t.TypeOf<typeof UserCodec>;

export enum UserActionTypes {
  FETCH = "@@user/FETCH",
  FETCH_PERMISSION = "@@user/FETCH_PERMISSION",
  FETCH_SUCCESS = "@@user/FETCH_SUCCESS",
  FETCH_ERROR = "@@user/FETCH_ERROR",
  SAVE_REQUEST = "@@user/SAVE_REQUEST",
  SAVE_SUCCESS = "@@user/SAVE_SUCCESS",
  SAVE_ERROR = "@@user/SAVE_ERROR",
  DELETE_REQUEST = "@@user/DELETE_REQUEST",
  DELETE_SUCCESS = "@@user/DELETE_SUCCESS",
  DELETE_ERROR = "@@user/DELETE_ERROR",
}

export interface UserState {
  readonly loading: boolean;
  readonly data: User | undefined;
  readonly errors?: string;
}
